var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLbCross16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon / cross",
  opacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon",
  d: "M12 4.00004L4 12M4 4.00004L12 12",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
export default SvgLbCross16;